import { useTypedSearchParams } from '@/hook';
import { VFlex } from '@/package';
import { VPagination } from '@/package/kiska/src/component/UI/VPagination';
import type { ModelingListSearchParams } from '@/type';

import { useDeploymentContext } from './hook';

const DeploymentListPagination = () => {
  const { count } = useDeploymentContext();
  const { get, set, flush } = useTypedSearchParams<ModelingListSearchParams>();
  const limit = Number(get('modelingLimit'));
  const offset = Number(get('modelingOffset'));

  const currentPage = Math.floor(offset / (limit || 1)) + 1;
  const totalPage = Math.ceil((count || 0) / (limit || 1));

  return (
    <>
      {!!count && (
        <VFlex justify="center" className="px-[10px] pt-4 pb-10">
          <VPagination
            currentPage={currentPage}
            totalPage={totalPage}
            onChange={page => {
              set('modelingOffset', `${(page - 1) * limit}`);
              flush();
            }}
          />
        </VFlex>
      )}
    </>
  );
};

export default DeploymentListPagination;
